define([
	"dojo/_base/declare",
	"csi",
	"csi/xml",
	"./NewThemeFromProductOnBreadcrumb"
], function(declare,csi,xml,NewThemeFromProductOnBreadcrumb) {

	return declare(NewThemeFromProductOnBreadcrumb, {
		preProcess: function() {
			// summary: do not allow action if style already has a theme
			var style = this.getParent();
			if (style.Theme != csi.EMPTY_URL) {
				this.displayErrorDialog({suffix:"_ErrorAlreadyHasTheme"});
			} else if (!style.Active) {
				this.displayErrorDialog({suffix:"_ErrorInactiveStyle"});
			} else {
				this.inherited(arguments);
			}
		},

		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set default value for Original Season on Theme create form
			this.inherited(arguments);

			if (view.getFixedValue) {
				view.addDefaultValue("ThemeSeason", this.getNode().ParentSeason);
				view.addDefaultValue("ThemeSeasons", [this.getNode().ParentSeason]);
			}
		}
	});
});